var _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgHomeRegular(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_991_18713)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.7383 23.9959C15.3243 23.9959 14.9883 23.6599 14.9883 23.2459V17.9959C14.9883 16.3419 13.6423 14.9959 11.9883 14.9959C10.3343 14.9959 8.98828 16.3419 8.98828 17.9959V23.2429C8.98828 23.6569 8.65228 23.9929 8.23828 23.9929H1.71628C0.766281 23.9909 -0.00871875 23.2159 -0.0117188 22.2669V9.74292C0.0162813 9.20592 0.236281 8.73392 0.606281 8.39192C0.622281 8.37692 0.643281 8.35992 0.664281 8.34392L11.5423 0.14392C11.6713 0.0469199 11.8313 -0.00708008 11.9933 -0.00708008C12.1553 -0.00708008 12.3163 0.0469199 12.4453 0.14392L23.3133 8.34392C23.3333 8.35892 23.3523 8.37492 23.3703 8.39192C23.7403 8.73492 23.9583 9.19892 23.9873 9.70092L23.9883 22.2689C23.9843 23.2189 23.2103 23.9939 22.2613 23.9969H22.2603H15.7383V23.9959ZM22.2593 22.4959C22.3843 22.4959 22.4883 22.3919 22.4883 22.2649V9.74292C22.4833 9.67692 22.4403 9.58492 22.3723 9.51392L11.9933 1.68292L1.60428 9.51392C1.53428 9.58692 1.49328 9.68292 1.48728 9.78492L1.48828 22.2659C1.48828 22.3909 1.59228 22.4939 1.71828 22.4939H7.48828V17.9959C7.48828 15.5149 9.50728 13.4959 11.9883 13.4959C14.4693 13.4959 16.4883 15.5149 16.4883 17.9959V22.4959H22.2593Z",
    stroke: "none",
    fill: "current"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_991_18713"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeRegular);
export default __webpack_public_path__ + "static/media/home-regular.e1c7a8ccb44d840c3590d4578620c114.svg";
export { ForwardRef as ReactComponent };